/**
 * subject-search.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, OnInit } from "@angular/core";

// TODO: this is an excellent case for a module
import { SearchPanelComponent } from "./search-panel.component";
import { SearchPanelAlternativeComponent }
  from "./search-panel-alternative.component";
import { SearchResultsTableComponent } from "./search-results-table.component";
import { SettingService } from "app/configuration/setting.service";

export const SEARCH_COMPONENTS : any[] = [
  SearchPanelComponent,
  SearchPanelAlternativeComponent,
  SearchResultsTableComponent
];

/* <search-panel-alternative *ngIf="useExperimental">
          </search-panel-alternative> */

@Component({
  // This is intended as a page, so no selector needed
  template: `
    <div class="container">
      <div class="row">
        <div class="col-sm-4">
          <h2>Search</h2>
          <!-- TODO: Instructions here? -->
          <search-panel></search-panel>
          <!-- alt here -->
        </div> <!-- /col -->
        <div class="col-sm-8">
          <search-results-table></search-results-table>
        </div> <!-- /col -->
      </div> <!-- /row -->

      <div class="row">
        <!-- search footer? -->
      </div> <!-- /row -->
    </div> <!-- /container -->
`
})
export class SubjectSearchComponent implements OnInit
{
  public useExperimental : boolean = false;
  /**
   * Construct a new {@link SubjectSearchComponent}.
   *
   */
  public constructor (settings : SettingService)
  {
    // this.useExperimental = settings.getOr("experimental search ui", false);
  }

  public ngOnInit () : void
  {
    // Nothing
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/search/subject-search.component.ts